export default "__VITE_ASSET__BlUSABi8__"